var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"map-container"},[_c('div',{attrs:{"id":"map-item"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }